import classnames from 'classnames';
import React from 'react';

const CSS = require('./SectionTitle.module.scss');

interface SectionTitleProps {
  children?: any;
  className?: string;
  bottomSpacing?: boolean;
}

function SectionTitle({
  children,
  className,
  bottomSpacing = false,
}: SectionTitleProps) {
  const classes = classnames(CSS.SectionTitle, {
    [CSS.BottomSpacing]: bottomSpacing,
    [className]: className,
  });

  return <h1 className={classes}>{children}</h1>;
}

export default SectionTitle;
